import dayjs from 'dayjs';

export function formatTime(val) {
    return dayjs(val).format('YYYY-MM-DD 00:00:00')
}

export function showYmd(val) {
    if(val){
        return dayjs(val).format('YYYY-MM-DD')
    }else{
        return ''
    }
}


// 字典相关
export function getDictKey(v, data) {
    let k;
    for (let i = 0; i < data.length; i++) {
        if (data[i]['dictValue'] == v) {
            k = data[i]['dictKey']
            break;
        }
    }
    return k;
}

export function getDictValue(k, data) {
    let v;
    for (let i = 0; i < data.length; i++) {
        if (data[i]['dictKey'] == k) {
            v = data[i]['dictValue']
            break;
        }
    }
    return v;
}
// elementUI
export function modifyDictData(data) { 
    data.forEach((item) => {
        item["value"] = item["dictKey"];
        item["label"] = item["dictValue"];
    });
    return data;
}
// 节流
export function debounce(func, wait) {
    let timeout;
    return function () {
        let context = this;
        let args = arguments;

        if (timeout) clearTimeout(timeout);
        
        timeout = setTimeout(() => {
            func.apply(context, args)
        }, wait);
    }
}
